import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

import { AccountPackageListComponent } from './account-package-list.component';
import { AccountPackageModule } from '../account-package/account-package.module';

@NgModule({
  declarations: [AccountPackageListComponent],
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    RippleModule,
    InputTextModule,
    DynamicDialogModule,
    AccountPackageModule,
  ],
  exports: [AccountPackageListComponent],
})
export class AccountPackageListModule {}
